<template>
  <div class="desk-wrapper" style="display: flex; flex-direction: column">
    <div class="common-box">
      <div class="common-title">工作台</div>
      <div class="desk-info-container">
        <div class="info">
          <el-avatar :size="72" :src="userInfo.avatar" fit="contain"></el-avatar>
          <div class="ml20">
            <div class="name mb10">
              早安，{{ userInfo.user_name }}，祝你开心每一天！
            </div>
            <div class="c9">{{ deptName }}</div>
          </div>
        </div>
        <div class="num-container" v-if="workbenchTopData.calledCnt != undefined">
          <div class="item">
            <div class="c9 mb5">呼叫订单数</div>
            <div class="num-family">{{ workbenchTopData.calledCnt }}</div>
            <!-- </div>
          <div class="item">
            <div class="c9 mb5">排名</div>
            <div class="num-family">{{workbenchTopData.topData.ranking}}</div> -->
          </div>
          <div class="item">
            <div class="c9 mb5">完成</div>
            <div class="num-family">{{ workbenchTopData.doneCnt }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-row type="flex" :gutter="10" class="mt10 flex-one">
      <el-col :span="16" class="flex-vertic">
        <deskOrder :title="true"></deskOrder>
        <div class="common-box mt10 flex-one">
          <div class="o-title flex border">
            工作信息<el-link :underline="false" @click="$router.push('/job/jobinformationList')">更多</el-link>
          </div>
          <div class="flex_33">
            <div class="info-list-item c9" v-for="item in infoList" :key="item.id" @click="seeDetailHandle(item)">
              <div class="ml10 mr10">
                <!-- <el-avatar :size="200"
                         shape="square"
                         :src="item.digest">
                               <img src="/img/bg/mr-img.png"/>
                         </el-avatar> -->
                <el-image style="border-radius: 20px; width: 300px; height: 200px"
                  :src="item.digest === '' ? '/img/bg/mr-img.png' : item.digest"
                  :preview-src-list="[item.digest === '' ? '/img/bg/mr-img.png' : item.digest]">
                </el-image>


                <div class="ovh">{{ item.title }}</div>
                <div>{{ item.createTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="common-box mt10 flex-one flex-vertic">
          <div class="o-title border">动态</div>
          <div class="flex-one"
               v-if="dynamicList.length > 0">
            <div class="info-list-item border flex c9"
                 v-for="item in 4"
                 :key="item">
              <el-avatar :size="40"
                         src="/img/bg/imh.png"></el-avatar>
              <div class="flex-one ovh ml10">
                <div class="ovh c3">
                  user 接收并确认了帮扶计划（张三+心理辅导）
                </div>
                <div>11天前</div>
              </div>
            </div>
            <div class="tar mt10">
              <el-pagination @current-change="handleCurrentChange"
                             :current-page="page1.current"
                             layout="prev, pager, next"
                             :total="page1.total">
              </el-pagination>
            </div>
          </div>
          <div v-if="dynamicList.length == 0"
               class="flex-one flex-v-c">
            <div class="empty-img"></div>
            <div class="c6">暂无数据</div>
          </div>
        </div> -->
      </el-col>
      <el-col :span="8" class="flex-vertic">
        <div class="common-box">
          <div class="o-title border">快速开始 / 便捷导航</div>
          <div>
            <el-button type="text" @click="$router.push('/order/index')">案件中心</el-button>
            <el-button type="text" @click="$router.push('/archives/index')">档案中心</el-button>
            <el-button type="text" @click="$router.push('/notice/index')">消息通知</el-button>
            <!-- <el-link class="mr15 mt5 mb5" :underline="false">案件中心</el-link>
                        <el-link class="mr15 mt5 mb5" :underline="false">消息通知</el-link>
                        <el-link class="mr15 mt5 mb5" :underline="false">档案中心</el-link> -->
            <!-- <el-button type="primary" icon="el-icon-plus" plain class="mt5 mb5">主要按钮</el-button> -->
          </div>
        </div>
        <div class="common-box mt10 flex-one">
          <div class="o-title border">热门呼叫词</div>
          <div class="hot-label-wrapper flex-one" style="height: 250px">
            <scatterchart style="height: 250px"></scatterchart>
          </div>
          <!-- <div class="o-title border">统计信息</div>
          <div class="tar">
            <el-radio-group v-model="radio4"
                            class="radio-checkbox"
                            size="mini">
              <el-radio-button label="机构帮扶对象统计"></el-radio-button>
              <el-radio-button label="按年龄"></el-radio-button>
              <el-radio-button label="按帮扶类型"></el-radio-button>
            </el-radio-group>
=======
        <div class="common-box flex-one flex-vertic">
          <div class="o-title border">热门呼叫词</div>
          <div class="hot-label-wrapper flex-one"
               style="height: 200px">
            <scatterchart></scatterchart>
757ff24dd9a87310b6b2ef7f323135ffd04cadef
          </div>
          <div class="pie-chart">
            <pie1></pie1>
          </div> -->
        </div>
        <div class="common-box mt10 flex-one">
          <div class="o-title border">工作信息统计</div>
          <div style="height: 300px;    display: flex;
    justify-content: center;
    align-items: center;">
            <testChart2 ref="testChart2" v-if="testChart2Show"></testChart2>
            <div class="avue-empty" v-else>
              <div class="avue-empty__image" style="height: 50px;"><img
                  src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                  alt=""></div>
              <p class="avue-empty__desc">暂无数据</p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="订单详情" append-to-body width="80%" :visible.sync="orderDetailVisible" custom-class="common-dialog">
      <orderDetail :detail="detailInfo" :initOrderId="initOrderId" :isOpt="isMode == 2" :isShenHe="isMode == 3"
        :printBtn="true" @close="
  orderDetailVisible = false;
refreshChange();
        ">
      </orderDetail>
    </el-dialog>
    <el-dialog title="工作信息详情" fullscreen append-to-body width="80%" :visible.sync="infoDetailVisible">
      <see :info="detail"></see>
    </el-dialog>
    <div class="common-box">
      <div class="o-title border flex mt20">
        <div>
          案件类型
          <span>(本年)</span>
        </div>
      </div>
      <div class="flex-one" style="height: 400px;display: flex;
    justify-content: center;
    align-items: center;">
        <ajbar ref="ajbar" v-if="ajbarShow"></ajbar>
        <div class="avue-empty" v-else>
          <div class="avue-empty__image" style="height: 50px;"><img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
              alt=""></div>
          <p class="avue-empty__desc">暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pie1 from "@/components/chart/pie1.vue";
import deskOrder from "./components/desk-order.vue";
import { starorderconfirmrecordList, workbenchTopData, workInfoData, caseTypeData } from "@/api/desk/index";
import { getPublishListDept } from "@/api/order/index";
import { getList } from "@/api/job/jobinformation";
import { mapGetters } from "vuex";
import { getDetail } from "@/api/job/jobinformation";
import see from "@/views/job/see.vue";
import ajbar from "@/components/chart/ajbar.vue";
import scatterchart from "@/components/chart/scatterchart.vue";
import testChart2 from "@/components/chart/testChart2.vue";



export default {
  components: {
    pie1,
    deskOrder,
    see,
    ajbar,
    scatterchart,
    testChart2
  },
  data() {
    return {
      testChart2Show: true,
      ajbarShow: true,
      workbenchTopData: {},
      infoDetailVisible: false,
      detail: {},
      radio4: "最新更新",
      infoList: [],
      page1: {
        current: 1,
        size: 10,
        total: 0,
      },
      deptName: "",
      dynamicList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.load();
    // 工作台-头部数据
    this.loadWorkbenchTopDataWay();
    // 工作台-工作信息统计
    this.loadWorkInfoDataWay();
    // 工作台-案件类型
    this.loadCaseTypeDataWay();
  },
  methods: {
    // 工作台-头部数据
    loadWorkbenchTopDataWay() {
      workbenchTopData({}).then((res) => {
        // console.log("头部数据",res.data.data);
        this.workbenchTopData = res.data.data;
      })
    },
    // 工作台-工作信息统计
    loadWorkInfoDataWay() {
      workInfoData({}).then((res) => {
        if (res.data.data == "") {
          this.testChart2Show = false;
          return;
        }
        console.log("工作信息统计",res.data.data);
        let dataList = [];
        for (let key in res.data.data) {
          let returnList = {
            name: '',
            value: 0
          }
          returnList.name = res.data.data[key].dataTypeName;
          returnList.value = res.data.data[key].cnt;
          dataList.push(returnList)
        }
        this.$refs.testChart2.setOptions(dataList);
      })
    },
    // 工作台-案件类型
    loadCaseTypeDataWay() {
      caseTypeData({}).then((res) => {
        // console.log("案件类型", res.data.data);
        if (res.data.data == "") {
          this.ajbarShow = false;
          return;
        }
        this.$refs.ajbar.setOptions(this.statisticsDataShift(res.data.data));
      })
    },
    statisticsDataShift(data) {
      let temp = {}
      data.map((item) => {
        let cur = temp[item.crimeType]
        if (cur) {
          cur.data[item.month - 1] = item.cnt
        } else {
          cur = {
            name: item.crimeTypeName,
            code: item.crimeType,
            data: [
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ]
          }
          cur.data[item.month - 1] = item.cnt
          temp[item.crimeType] = cur
        }
      })
      let seriesList = [];
      for (let key in temp) {
        seriesList.push(temp[key]);
      }
      return seriesList;
    },
    load() {
      getPublishListDept().then((res) => {
        let dept = res.data.data.find((v) => v.id == this.userInfo.dept_id);
        this.deptName = dept.deptName;
      });
      starorderconfirmrecordList(this.page1.current, this.page1.size).then(
        (res) => {
          this.dynamicList = this.dynamicList.concat(res.data.data.records);
          this.page1.total = res.data.data.total;
        }
      );
      getList(1, 6).then((res) => {
        const data = res.data.data;
        this.infoList = data.records;
      });
    },
    handleCurrentChange(val) {
      this.page1.current = val;
      this.load();
    },
    seeDetailHandle(row) {
      getDetail(row.id).then((res) => {
        this.detail = res.data.data;
        this.infoDetailVisible = true;
      });
    },
    errorHandler() {
      return true
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/moudles/desk.scss";
</style>
<style lang="scss">
.desk-wrapper {
  .avue-crud__menu {
    display: none;
  }

  .el-avatar {
    background-color: #fff;
  }
}
</style>
